import React from 'react';

import { Icon, Paragraph } from '@zillow/constellation-10';
import { IconTrophyFilled } from '@zillow/constellation-icons';

const ConfirmationThanks = () => (
  <>
    <Icon size="xl" css={{ color: 'icon.accent.blue.hero' }} render={<IconTrophyFilled />} />
    <Paragraph css={{ textStyle: 'heading-sm', marginBlock: '400' }}>
      This listing will be deactivated as of today.
    </Paragraph>
    <Paragraph>Your advertising period will be included on your next invoice.</Paragraph>
  </>
);

export default ConfirmationThanks;
